import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import * as Sentry from "@sentry/browser"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"
import type SessionStore from "cc-frontend/services/session-store"
import { Resource } from "ember-could-get-used-to-this"
import { isNil } from "lodash-es"
import { tracked } from "tracked-built-ins"

export default class AcceptInvite extends Resource<[]> {
  @service("ember-store") store!: EmberStore
  @service sessionStore!: SessionStore
  @service rpc!: Rpc
  @service session!: Session

  invite: any

  declare args: any

  @tracked isProcessing = true
  @tracked result = "IS_PROCESSING"
  @tracked isAccepted = false

  setup() {
    this.invite = this.args.positional[0]
    this._acceptInvite()
  }

  get isAuthenticating() {
    return this.session.isAuthenticating
  }

  _acceptInvite() {
    if (isNil(this.invite)) {
      this.result = "NOT_FOUND"
      Sentry.withScope((scope) => {
        scope.setLevel(Sentry.Severity.Error)
        Sentry.captureMessage("Invite ID not found")
      })
      return
    }
    if (this.session.isAuthenticating === null || this.session.isAuthenticating === true) {
      later(() => {
        this._acceptInvite()
      }, 200)
      return
    }
    if (!isNil(this.invite.attributes.acceptedOn)) {
      this.isProcessing = false
      this.result = "ALREADY_ACCEPTED"
      return
    }
    if (this.session.isAuthenticated === false) {
      // We'll know this immediately, so we don't wnat the screen to immediately flash.
      later(() => {
        // Set a property on localStorage to record this invite
        this.sessionStore.persistObject("invite", {
          id: this.invite.id,
        })
        this.isProcessing = false
        this.result = "MUST_SIGN_IN"
      }, 2000)
    } else if (this.session.isAuthenticated === true) {
      this.rpc
        .invite_accept({
          id: this.invite.id,
        })
        .then(() => {
          later(() => {
            this.isProcessing = false
            this.result = "SUCCESS"
          }, 1000)
        })
    }
  }

  update() {
    let invite = this.args.positional[0]
    // The entire query changes
    if (invite !== this.invite.id) {
      this.invite = invite
      this._acceptInvite()
    }
  }

  teardown() {
    // we'll unsubscribe from it here.
  }
}
